import { useEffect, useState } from 'react';

import { Nullable } from '@/utils/globalTypes';

const DEFAULT_THRESHOLD = [0.5];

type UseElementVisibilityProps<T> = {
  element: Nullable<T>;
  thresholds?: number[];
};

const useElementVisibility = <TElement extends HTMLElement = HTMLElement>({
  element,
  thresholds = DEFAULT_THRESHOLD,
}: UseElementVisibilityProps<TElement>) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const options: Pick<IntersectionObserver, 'root' | 'thresholds'> = {
      root: null,
      thresholds,
    };

    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (!element) return;

      observer.unobserve(element);
    };
  }, [element, thresholds]);

  return isVisible;
};

export default useElementVisibility;
